import React from 'react';
import { DataTableColumn, DataTableRow } from './types';
import { getAlign, getSize } from './utils';

const TableRow = ({
  columns,
  row,
  stickyFirstColumn = false,
  onRowClick,
  selectedRowId,
  isFirstRow = false,
  isLastRow = false,
}: {
  columns: DataTableColumn[],
  row: DataTableRow;
  stickyFirstColumn?: boolean;
  onRowClick?: (row: DataTableRow) => void;
  selectedRowId?: string | null;
  isFirstRow?: boolean;
  isLastRow?: boolean;
}) => {
  const isSelected =
    selectedRowId != null &&
    row.id != null &&
    String(row.id) === String(selectedRowId);

  const renderCell = (column: DataTableColumn) => {
    if (column.options?.render) {
      return column.options.render(row);
    }
    if (column.options?.renderLite) {
      return column.options.renderLite(row[column.key]);
    }
    return row[column.key];
  };

  const stickyFirstClasses = stickyFirstColumn
    ? 'first:tw-sticky first:tw-left-0 first:tw-z-10'
    : '';

  const tdClassName = [
    'tw-py-2 tw-px-2 tw-text-foreground',
    'tw-border-b tw-border-x-0 tw-border-border tw-border-solid',
    isFirstRow ? 'tw-border-t' : 'tw-border-t-0',
    'first:tw-pl-4 last:tw-pr-4 first:tw-border-l last:tw-border-r',
    stickyFirstClasses,
    +(isSelected ? ' first:!tw-bg-muted' : ' first:tw-bg-card'),
    isFirstRow ? 'first:tw-rounded-tl-lg last:tw-rounded-tr-lg' : '',
    isLastRow ? 'first:tw-rounded-bl-lg last:tw-rounded-br-lg' : '',
  ].filter(Boolean).join(' ');

  const handleRowClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
    if (onRowClick) {
      e.stopPropagation();
      onRowClick(row);
    }
  };
  const isSelectedClassName = isSelected
  ? 'tw-bg-gray-50'
  : 'tw-bg-card';

  return (
    <tr
      className={[
        'tw-table-row',
        isSelectedClassName,
        onRowClick ? ' tw-cursor-pointer hover:tw-bg-gray-50' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-selected={isSelected}
      onClick={handleRowClick}
    >
      {columns.map((column, index) => (
        <td
          className={`${tdClassName} ${column?.className || ''}`}
          // eslint-disable-next-line react/no-array-index-key
          key={`${column.key}-${index}`}
          style={{
            width: getSize(column?.options?.size, columns),
          }}
        >
          <div className={`tw-flex tw-flex-row tw-items-center tw-gap-2 ${getAlign(column.options?.align)}`}>
            {renderCell(column)}
          </div>
        </td>
      ))}
    </tr>
  );
};

export default TableRow;
